import React, { useMemo } from 'react';

import { truncateName } from '@eika-infrastruktur/format';
import { AttentionLabel } from '@eika/label';

import type { Account } from '../../../../generated-types';
import useTranslation, { format } from '../../../../hooks/useTranslation';
import { OutboxWrapper } from '../../../../models/outbox';

type Props = {
    outboxListItem: OutboxWrapper;
    targetAccount: Account | undefined;
};

const OutboxFromAccountLabel: React.FC<Props> = ({ outboxListItem, targetAccount }) => {
    const translated = useTranslation();

    const { approvers, initiator } = outboxListItem;

    const firstApprover = useMemo(() => {
        return approvers?.find((x) => x.firstApprover === true);
    }, [approvers]);

    const accountHasMultipleOwners =
        targetAccount &&
        targetAccount.owners.length > 0 &&
        !!targetAccount.owners.find((owner) => !owner.equalToUserLoggedOn);
    const accountHasMultipleApprovers =
        targetAccount && typeof targetAccount.numberOfApprovers === 'number' && targetAccount.numberOfApprovers > 1;

    if (!accountHasMultipleOwners && !accountHasMultipleApprovers) return undefined;

    if (firstApprover?.name) {
        return (
            firstApprover?.name && (
                <AttentionLabel
                    size="small"
                    text={format(translated.outbox.paidBy, truncateName(firstApprover.name))}
                />
            )
        );
    }

    if (!initiator?.name && !initiator?.loggedInUser) {
        return undefined;
    }

    return (
        <AttentionLabel
            size="small"
            text={format(
                translated.createdBy,
                initiator.loggedInUser === true ? translated.you : truncateName(initiator?.name),
            )}
        />
    );
};

export default OutboxFromAccountLabel;
